// extracted by mini-css-extract-plugin
export default {"wrapper":"src-components-molecule-presetEntry-presetEntry-module__wrapper--VTRMK","actions":"src-components-molecule-presetEntry-presetEntry-module__actions--n5HG_"};